import NewNavbar from "./NewNavbar";
import { useEffect, useState } from "react";
import axios from "axios";

export default function NewBlogPage() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get("https://api.livestockify.com/api/admin/blogs")
      .then((res) => {
        setBlogs(res.data);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <>
      <NewNavbar />

      <section className="py-16 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            {/* Image */}
            <div className="w-full">
              <img
                src={blogs[0]?.imageURL}
                alt="Wastewater Management"
                className="w-full h-[220px] sm:h-[260px] md:h-[300px] object-cover rounded-xl"
              />
            </div>

            {/* Content */}
            <div>
              {/* Badge */}
              <span className="inline-block bg-[#6FAF1E] text-white text-xs px-3 py-1 rounded-full mb-4">
                New !
              </span>

              {/* Title */}
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
                {/* Reimagining Wastewater Management with Smart STP Solutions */}

                {blogs[0]?.blogTitle}
              </h2>

              {/* Description */}
              <p className="text-gray-600 mt-4 text-sm md:text-base leading-relaxed max-w-lg">
                {/* Learn how Kuppismart integrates IoT technology to monitor,
                analyze, and optimize sewage treatment plants, ensuring
                compliance, efficiency, and environmental sustainability. */}

                {blogs[0]?.blogTitle}
              </p>

              {/* Read More */}

              <button
                onClick={() => window.open(blogs[0]?.blogLink, "_blank")}
                className="mt-6 flex items-center gap-2 text-[#0F6D73] font-medium hover:gap-3 transition-all"
              ></button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="mb-12">
            <h2 className="text-2xl text-start md:text-3xl font-bold">
              Our Recent <span className="text-[#6FAF1E]">Articles</span>
            </h2>
            <p className="text-gray-600 text-start text-sm mt-1">
              Stay informed with our latest insights
            </p>
          </div>

          {/* Cards Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {/* {[1, 2, 3, 4, 5, 6].map((item, index) => ( */}

            {blogs.slice(1).map((item, index) => (
              <div key={index} className="group">
                {/* Image */}
                <div className="overflow-hidden rounded-xl">
                  <img
                    // src="YOUR_IMAGE_URL"
                    src={item.imageURL}
                    alt="article"
                    className="w-full h-[200px] object-cover rounded-xl group-hover:scale-105 transition duration-300"
                  />
                </div>

                {/* Meta */}
                <div className="flex justify-between items-center mt-3 text-sm">
                  <span className="text-[#6FAF1E] font-medium">Ramulu</span>
                  <span className="text-gray-500">02 Mar 2026</span>
                </div>

                {/* Title */}
                <h3 className="mt-2 text-lg font-semibold text-gray-900 leading-snug">
                  {blogs[0]?.blogTitle}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-sm mt-2 leading-relaxed">
                  {blogs[0]?.blogTitle}
                </p>

                {/* Read More */}
                <button className="mt-4 flex items-center gap-2 text-[#0F6D73] font-medium hover:gap-3 transition-all">
                  Read More
                  <span>→</span>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
